import { render, staticRenderFns } from "./ReferralCounter.vue?vue&type=template&id=17a7bdaa&scoped=true"
import script from "./ReferralCounter.vue?vue&type=script&lang=js"
export * from "./ReferralCounter.vue?vue&type=script&lang=js"
import style0 from "./ReferralCounter.vue?vue&type=style&index=0&id=17a7bdaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a7bdaa",
  null
  
)

export default component.exports